import { MakeCall } from './createMakeCall';

const requestActivationEmail =
  (makeCall: MakeCall) => (userId: number | 'me') =>
    makeCall<undefined>('PUT', `/api/v2/user/${userId}/activate`);
export { requestActivationEmail };
